import { ISSUER_HANDLER_KEYS } from 'components/modules/Insurance/components/Policyholder/Policyholder.constants';
import { FIELDS } from 'store/insuranceAnketa/constants';

import { ADDRESS_HANDLER_MAP } from './Passport.constants';

export const addressHandler = ({ type, value }) => {
  const map = ADDRESS_HANDLER_MAP[type];

  return Object.entries(map).reduce((acc, [valueKey, storeKey]) => {
    if (typeof storeKey !== 'undefined') {
      acc.push({ key: storeKey, value: value[valueKey] });
    }

    return acc;
  }, []);
};

export const issuerInfoHandler = ({
  value: { [ISSUER_HANDLER_KEYS.CODE]: issuerCode, [ISSUER_HANDLER_KEYS.NAME]: issuerName },
}) => {
  const result = [];

  if (typeof issuerCode !== 'undefined') {
    result.push({ key: FIELDS.PASSPORT_ISSUER_CODE, value: issuerCode });
  }

  if (typeof issuerName !== 'undefined') {
    result.push({ key: FIELDS.PASSPORT_ISSUER, value: issuerName });
  }

  return result;
};

export const generateAddress = (address = {}) => {
  const result = [];

  if (address.regionWithType) {
    result.push(address.regionWithType);
  } else if (address.regionName) {
    result.push(address.regionName);
  }

  if (address.cityName) {
    result.push(address.cityName);
  }

  if (address.settlementName) {
    result.push(`${address.settlementType} ${address.settlementName}`);
  }

  if (address.streetName) {
    result.push(`${address.streetType} ${address.streetName}`);
  }

  if (address.houseNumber) {
    result.push(`${address.houseType} ${address.houseNumber}`);
  }

  if (address.building) {
    result.push(`${address.buildingType} ${address.building}`);
  }

  if (address.apartmentNumber) {
    result.push(`${address.apartmentType} ${address.apartmentNumber}`);
  }

  return result.join(', ');
};
